import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { MediaItemDetails } from '../media-item-details';
import { InspectionPoint } from './inspection-point';
import { InspectionPointType } from './inspection-point-type';

export class DrawingInspectionDetails implements ViewModel {
  readonly friendlyTypeNameSingular: string = 'Drawing Inspection Details';
  readonly apiRoute: string = CONFIG.apiRoutes.drawingInspectionDetails;

  mediaItemDetailsId: string;
  mediaItemDetails: MediaItemDetails;
  inspectionPoints: InspectionPoint[] = [];
  inspectionPointTypes: InspectionPointType[] = [];
  fileLastModified: Date;

  constructor() {
  }

  public json(): any {
    return this;
  }

  loadFromJson(data: any) {
    this.mediaItemDetailsId = data.mediaItemDetailsId;

    this.mediaItemDetails = new MediaItemDetails();

    if (data.mediaItemDetails) {
      this.mediaItemDetails.loadFromJson(data.mediaItemDetails);
    }

    this.inspectionPoints = [];
    if (data.inspectionPoints) {
      data.inspectionPoints.forEach(inspectionPoint => {
        const newInspectionPoint = new InspectionPoint();
        newInspectionPoint.loadFromJson(inspectionPoint);
        this.inspectionPoints.push(newInspectionPoint);
      });
    }

    this.inspectionPointTypes = [];
    if (data.inspectionPointTypes) {
      data.inspectionPointTypes.forEach(inspectionPointType => {
        const newInspectionPointType = new InspectionPointType();
        newInspectionPointType.loadFromJson(inspectionPointType);
        this.inspectionPointTypes.push(newInspectionPointType);
      });
    }

    this.fileLastModified = data.fileLastModified;
  }
}
